<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button @click="createGenericProduct()" class="bg_l_green">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewGenericProduct") }}
            </vs-button>
          </div>
        </div>
        <create-popup
          :show="CreatePopup"
          :model="modalModel"
          @finish="onfinish"
          @close="closeCreatePopup"
        ></create-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('ID') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">
                  {{ row.name }}
                </td>
                <td style="direction: ltr; width: 20%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 20%">
                  {{ row.id }}
                </td>
                <td style="width: 30%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="bordered-btn"
                    @click.prevent="genericProductItemsPopup(row)"
                    v-has-permission="permission148"
                    >{{ $t("Subset") }}</vs-button
                  >
                  <router-link :to="{ path: '/GenericProduct/Edit/' + row.id }">
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="ml-4 d-inline"
                    ></vs-button>
                  </router-link>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteGenericProduct(row.id)"
                    class="d-inline"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
            <subset-popup
              :showGenericItemsPopup="showGenericItemsPopup"
              :genericProductItemsmodel="genericProductItemsmodel"
              @finish="closeGenericItemsPopup"
            ></subset-popup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";
import SubsetPopup from "./SubsetPopup.vue";

export default {
  components: {
    CreatePopup,
    DataGrid,
    SubsetPopup,
  },
  data() {
    return {
      permission148: "AssignGenericProductItem|UnAssignGenericProductItem",
      CreatePopup: false,
      showGenericItemsPopup: false,
      modalModel: {},
      itemList: [],
      genericProductItemsmodel: {},
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/GenericProductsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      removeGenericProduct: "genericProduct/remove",
    }),
    ////Open Modal Create
    createGenericProduct() {
      this.modalModel = {};
      this.CreatePopup = true;
    },
    genericProductItemsPopup(model) {
      this.genericProductItemsmodel = model;
      this.showGenericItemsPopup = true;
    },
    //Delete Method
    deleteGenericProduct(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeGenericProduct(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeCreatePopup() {
      this.CreatePopup = false;
    },
    onfinish() {
      this.closeCreatePopup();
      this.$refs.grid.renderGrid();
    },
    closeGenericItemsPopup() {
      this.showGenericItemsPopup = false;
    },
  },
};
</script>
